import { Formik, FormikHelpers } from "formik";
import { FC } from "react";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { FaFilter } from "react-icons/fa";
import yup from "app/util/yup";
import { StatusAlert } from "app/component/form/StatusAlert";

type Props = {
    initialValues: FormValues;
    onSubmit: (values: FormValues) => void;
};

export type FormValues = {
    firstName?: string;
    lastName?: string;
    email?: string;
};

const schema: yup.ObjectSchema<FormValues> = yup.object({
    firstName: yup.string(),
    lastName: yup.string(),
    email: yup.string(),
});

export const UsersTableFiltersForm: FC<Props> = (props) => {
    const onSubmit = (values: FormValues, actions: FormikHelpers<FormValues>) => {
        props.onSubmit(values);
        actions.setSubmitting(false);
    };

    return (
        <Formik validationSchema={schema} onSubmit={onSubmit} initialValues={props.initialValues}>
            {({ handleSubmit, handleChange, handleBlur, values, isSubmitting, errors, touched, status }) => (
                <Form noValidate onSubmit={handleSubmit}>
                    <StatusAlert status={status as unknown} />
                    <Form.Group className="mb-3">
                        <Form.Label>First name</Form.Label>
                        <Form.Control
                            type="search"
                            name="firstName"
                            value={values.firstName ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.firstName && !!errors.firstName}
                        />
                        <Form.Control.Feedback type="invalid">{errors.firstName}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Last name</Form.Label>
                        <Form.Control
                            type="search"
                            name="lastName"
                            value={values.lastName ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.lastName && !!errors.lastName}
                        />
                        <Form.Control.Feedback type="invalid">{errors.lastName}</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                            type="search"
                            name="email"
                            value={values.email ?? ""}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            isInvalid={touched.email && !!errors.email}
                        />
                        <Form.Control.Feedback type="invalid">{errors.email}</Form.Control.Feedback>
                    </Form.Group>
                    <Button type="submit" disabled={isSubmitting}>
                        <FaFilter /> Filter
                    </Button>
                </Form>
            )}
        </Formik>
    );
};
